import userManagement from "./UserManagement";
import auth from "./Auth";
import dashboard from "./Dashboard";
import manageCms from "./ManageCms/index";
import adminProfile from "./AdminAccount/index";
import BookManagement from "./BookManagement";
import BookCategoryManagement from "./BookCategoryManagement";
import SubscriptionManagement from "./ManageSubscription";
import NotificationManagement from "./NotificationManagement";
import TransactionManagement from "./TransactionManagement";
import BookRequest from "./BookRequest";

/**
 * Combine and export access control modules related to various features such as user management, authentication, dashboard, CMS management, and admin account.
 * @constant {Object} AccessControl
 */
const AccessControl = {
  ...userManagement,
  ...auth,
  ...dashboard,
  ...manageCms,
  ...adminProfile,
  ...BookManagement,
  ...BookCategoryManagement,
  ...SubscriptionManagement,
  ...NotificationManagement,
  ...TransactionManagement,
  ...BookRequest,
};

export default AccessControl;
